export default __webpack_public_path__ + "static/media/llamado 1@2x.f935dcc8.jpg";